import axios from 'axios';
import {API_URL_PREFIX, axiosAuthHeader} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/test';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + '/all');
  }

  getUserBoard() {
    return axios.get(API_URL + '/user', axiosAuthHeader());
  }

  getModeratorBoard() {
    return axios.get(API_URL + '/mod', axiosAuthHeader());
  }

  getAdminBoard() {
    return axios.get(API_URL + '/admin', axiosAuthHeader());
  }
}

export default new UserService();
